var _path, _path2, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyApp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 35H27.5V32H24.5V35Z",
    fill: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 17C22.685 17 20 19.685 20 23H23C23 21.35 24.35 20 26 20C27.65 20 29 21.35 29 23C29 26 24.5 25.625 24.5 30.5H27.5C27.5 27.125 32 26.75 32 23C32 19.685 29.315 17 26 17Z",
    fill: "#DADADA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 50,
    rx: 9.5,
    stroke: "#D9D9D9",
    strokeDasharray: "5 5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyApp);
export default __webpack_public_path__ + "static/media/emptyApp.eb437e0c063720473bcb7a3640361604.svg";
export { ForwardRef as ReactComponent };